import { render } from "./PrivacyComponent.vue?vue&type=template&id=ba44c79e&scoped=true"
const script = {}

import "./PrivacyComponent.vue?vue&type=style&index=0&id=ba44c79e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba44c79e"]])

export default __exports__